import { create } from 'zustand';
import axios from 'axios';
import { CURRENCY_ORDER } from '../constants/currencies';

const currencies = CURRENCY_ORDER;

const toDecimalMoney = (value) => Number(value || 0);

const emptyCurrencyMap = (source = {}) => (
  currencies.reduce((acc, currency) => {
    acc[currency] = Number(source[currency] || 0);
    return acc;
  }, {})
);

const normalizeBalanceGroup = (source = {}) => {
  const byCurrency = emptyCurrencyMap(source.byCurrency || source);
  return {
    tryTotal: Number(source.tryTotal || 0),
    byCurrency
  };
};

const normalizeOpenInvoices = (openInvoices = {}) => normalizeBalanceGroup(openInvoices);

const normalizeCariMetrics = (cariMetrics = {}) => {
  const receivables = normalizeBalanceGroup(cariMetrics.receivables || { byCurrency: cariMetrics.credit });
  const payables = normalizeBalanceGroup(cariMetrics.payables || { byCurrency: cariMetrics.debit });

  return {
    credit: receivables.byCurrency,
    debit: payables.byCurrency,
    receivables,
    payables
  };
};

const normalizePersonnelBalances = (personnelBalances = {}) => ({
  payableTry: Number(personnelBalances.payableTry || 0),
  receivableTry: Number(personnelBalances.receivableTry || 0),
  entitlementByCurrency: emptyCurrencyMap(personnelBalances.entitlementByCurrency),
  outflowByCurrency: emptyCurrencyMap(personnelBalances.outflowByCurrency),
  inflowByCurrency: emptyCurrencyMap(personnelBalances.inflowByCurrency)
});

const normalizeDashboardData = (data) => {
  if (!data) return data;

  const financialSummary = { ...(data.financialSummary || {}) };
  const openInvoices = normalizeOpenInvoices(data.openInvoices || financialSummary.openInvoices);
  const cariMetrics = normalizeCariMetrics(data.cariMetrics || financialSummary.cariMetrics);
  const personnelBalances = normalizePersonnelBalances(
    data.personnelBalances || financialSummary.personnelBalances
  );

  return {
    ...data,
    openInvoices,
    cariMetrics,
    personnelBalances,
    financialSummary: {
      ...financialSummary,
      openInvoices,
      cariMetrics,
      personnelBalances
    }
  };
};

const useDashboardStore = create((set) => ({
  dashboardData: null,
  loading: false,
  error: null,

  fetchDashboardStats: async () => {
    set({ loading: true, error: null });
    try {
      const response = await axios.get('/api/dashboard/stats');
      const rawData = response.data.data || response.data;
      const dashboardData = normalizeDashboardData(rawData);

      set({
        dashboardData,
        loading: false,
        error: null
      });

      return dashboardData;
    } catch (err) {
      const message = err.response?.data?.message || 'Dashboard verileri yüklenemedi.';
      set({
        dashboardData: null,
        loading: false,
        error: message
      });
      return null;
    }
  }
}));

export { toDecimalMoney };
export default useDashboardStore;
